module.exports = __webpack_public_path__ + "img/u2416.7481b927.svg";